export default "https://cdn-static.gokick.com/assets/ec4df3605d889435bba193590f9e5f4fca0b05f8/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";